import { useTranslation } from 'react-i18next'
import { Box, Fade, IconButton, Tooltip, Typography } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'
import CustomChip from '../../../../../shared/components/CustomChip'

const NoveltiesStatusHeader = () => {
  const { t } = useTranslation(['global'])

  return (
    <Box display="flex" justifyContent="center">
      <Typography variant="h5" align="center">
        {t('all')}
      </Typography>
      <Tooltip
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        arrow
        title={
          <Box>
            <Typography variant="body2">{t('status')}:</Typography>
            <Box display="flex" gap={1} alignItems="center">
              <CustomChip size="small" color="primary" />
              <Typography variant="caption">{t('active')}</Typography>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              <CustomChip size="small" color="secondary" />
              <Typography variant="caption">{t('inactive')}</Typography>
            </Box>
            <Box display="flex" gap={1} alignItems="center">
              <CustomChip size="small" color="grey" />
              <Typography variant="caption">{t('draft')}</Typography>
            </Box>
          </Box>
        }
      >
        <IconButton>
          <InfoOutlined htmlColor={'#8F99A3'} fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default NoveltiesStatusHeader
